import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { IResolutionVoteProps } from "../types/interfaces/IResolutionVoteProps";

//This component is responsible for rendering the radio buttons for the vote.
//Props: The support flag boolean and onSupportFlagChange function are passed in from the caller.
const ResolutionVote: React.FC<IResolutionVoteProps> = ({ supportFlag, onSupportFlagChange }) => {
    
    //Function to handle a resolution response supports flag change.
    const supportFlagChange = (value: boolean) => {
        onSupportFlagChange(value);
    }

    return (
        <FormControl>
            <Typography variant="h6" color="primary.dark" component="div">
                <Box sx={{ fontWeight: 'bold' }}>Do you support this resolution?</Box>
            </Typography>
            <RadioGroup>
                <FormControlLabel 
                    checked={supportFlag === true} 
                    onChange={() => supportFlagChange(true)} 
                    value="Yes" 
                    control={<Radio />} 
                    label="Yes" />
                <FormControlLabel 
                    checked={supportFlag === false}
                    onChange={() => supportFlagChange(false)}
                    value="No" 
                    control={<Radio />} 
                    label="No" />
            </RadioGroup>
        </FormControl>
    );
}

export default ResolutionVote;